<div class="container d-flex flex-column h-100">
  <div class="d-flex flex-column flex-grow-1">
    <h3 class="text-center">LOA has been created successfully</h3>
    <mat-divider class="mb-3"></mat-divider>
    <h4 class="pb-3">Agreement has been signed for company "{{ customerCompany?.customerName }}" and third party company "{{ providerCompany?.name }}"
      using line
      of business as "{{ descriptionFromLob(selectedLOB) }}"</h4>
    <div *ngIf="lineOfBusiness.length > 0">
      <ng-container *ngTemplateOutlet="multiPersona"></ng-container>
    </div>
  </div>
  <div class="d-flex justify-content-end pt-2">
    <button mat-stroked-button color="warn" class="mr-3" aria-label="No Button" (click)="emitCancel()" *ngIf="lineOfBusiness.length > 0">
      No
    </button>
    <button mat-flat-button color="accent" aria-label="Ok Button" (click)="emitAction()">
      Ok
    </button>
  </div>
</div>

<ng-template #multiPersona>
  <div class="pb-3">Do you want to sign another agreement with different line of business?</div>
  <div class="pb-3">Select a line of business to sign a new agreement:</div>
  <div class="list-container overflow-auto flex-grow-1">
    <h4>Line Of Business</h4>
    <div class="d-flex justify-content-start">
      <mat-radio-group aria-label="Line Of Business">
        <div class="d-flex flex-column">
          <mat-radio-button class="mb-2 ml-2" *ngFor="let lob of lineOfBusiness" [value]="lob.role"
                            [name]="lob.role"
                            [checked]="lineOfBusiness.length > 0 && lineOfBusiness[0].description === lob.description" (change)="selectLob($event)">
            {{ description(lob.role) }}
          </mat-radio-button>
        </div>
      </mat-radio-group>
    </div>
  </div>
</ng-template>
